// Centralized data-testid registry for QA / testing agent.
export const HOME = {
  emergentLink: "home-emergent-link",
};

export const LANDING = {
  brandCta: "landing-brand-cta",
  creatorCta: "landing-creator-cta",
  loginLink: "landing-login-link",
  registerBrand: "landing-register-brand",
  registerCreator: "landing-register-creator",
  // Founding banner (Sprint LP-1)
  foundingBanner: "landing-founding-banner",
  // Pagamento Protegido section
  paymentSection: "landing-payment-section",
  paymentStep1: "landing-payment-step-1",
  paymentStep2: "landing-payment-step-2",
  paymentStep3: "landing-payment-step-3",
  paymentStep4: "landing-payment-step-4",
  paymentStep5: "landing-payment-step-5",
  // Selo Digital section
  certificateSection: "landing-certificate-section",
  // Preço section
  pricingSection: "landing-pricing-section",
  pricingTake: "landing-pricing-take",
  pricingMonthly: "landing-pricing-monthly",
  pricingPix: "landing-pricing-pix",
  // Comparação
  comparisonSection: "landing-comparison-section",
  comparisonTable: "landing-comparison-table",
  // FAQ (planned)
  faqSection: "landing-faq-section",
  faqTabAll: "faq-tab-all",
  faqTabBrand: "faq-tab-brand",
  faqTabCreator: "faq-tab-creator",
  faqTabGeneral: "faq-tab-general",
  faqItem: "faq-item", // followed by index (faq-item-1..13)
};

export const AUTH = {
  emailInput: "auth-email-input",
  passwordInput: "auth-password-input",
  nameInput: "auth-name-input",
  nicheSelect: "auth-niche-select",
  citySelect: "auth-city-input",
  companyInput: "auth-company-input",
  submitBtn: "auth-submit-btn",
  switchLink: "auth-switch-link",
  logoutBtn: "auth-logout-btn",
  errorMsg: "auth-error-msg",
};

export const BRAND = {
  dashboard: "brand-dashboard",
  kpiCampaigns: "brand-kpi-campaigns",
  kpiEscrow: "brand-kpi-escrow",
  kpiCreators: "brand-kpi-creators",
  kpiSpend: "brand-kpi-spend",
  newCampaignBtn: "brand-new-campaign-btn",
  discoverBtn: "brand-discover-btn",
  contractsTable: "brand-contracts-table",
  // Discover
  filterType: "brand-filter-type",
  filterNiche: "brand-filter-niche",
  filterMinFollowers: "brand-filter-min-followers",
  filterEngagement: "brand-filter-engagement",
  applyFilters: "brand-apply-filters",
  creatorCard: "brand-creator-card",
  hireBtn: "brand-hire-btn",
  hireDialog: "brand-hire-dialog",
  hireAmount: "brand-hire-amount",
  hirePackage: "brand-hire-package",
  hireConfirm: "brand-hire-confirm",
  // Campaign form
  campaignTitle: "campaign-title-input",
  campaignBudget: "campaign-budget-input",
  campaignNiche: "campaign-niche-select",
  campaignInstructions: "campaign-instructions-input",
  campaignSubmit: "campaign-submit-btn",
  // Contracts
  approveBtn: "brand-contract-approve-btn",
};

export const CREATOR = {
  dashboard: "creator-dashboard",
  walletAvailable: "creator-wallet-available",
  walletPending: "creator-wallet-pending",
  walletWithdrawn: "creator-wallet-withdrawn",
  withdrawBtn: "creator-withdraw-btn",
  withdrawAmount: "creator-withdraw-amount",
  withdrawPix: "creator-withdraw-pix",
  withdrawConfirm: "creator-withdraw-confirm",
  feed: "creator-feed",
  feedCard: "creator-feed-card",
  submitBigBtn: "creator-submit-big-btn",
  // Financial (Sprint K2)
  financialNav: "nav-creator-financial",
  financialPage: "creator-financial-page",
  financialYearSelect: "creator-financial-year-select",
  financialDownloadPdf: "creator-financial-download-pdf",
  financialKpiAvailable: "creator-financial-kpi-available",
  financialKpiPending: "creator-financial-kpi-pending",
  financialKpiNet: "creator-financial-kpi-net",
  financialKpiWithdrawn: "creator-financial-kpi-withdrawn",
  financialGross: "creator-financial-gross",
  financialFee: "creator-financial-fee",
  financialMonthly: "creator-financial-monthly",
  financialTable: "creator-financial-table",
  financialEmpty: "creator-financial-empty",
  // Profile
  profileBio: "creator-profile-bio",
  profileNiche: "creator-profile-niche",
  profileType: "creator-profile-type",
  profilePixKey: "creator-profile-pix",
  profilePriceUgc1: "creator-price-ugc1",
  profilePriceUgc3: "creator-price-ugc3",
  profilePriceCombo: "creator-price-combo",
  profilePortfolioInput: "creator-portfolio-input",
  profilePortfolioAdd: "creator-portfolio-add",
  profileSaveBtn: "creator-profile-save",
  connectInsta: "creator-connect-insta",
  connectTiktok: "creator-connect-tiktok",
  connectHandle: "creator-connect-handle",
  connectConfirm: "creator-connect-confirm",
  // Submit content
  submitDialog: "creator-submit-dialog",
  submitContentUrl: "creator-submit-content-url",
  submitContentConfirm: "creator-submit-content-confirm",
};

export const ADMIN = {
  dashboard: "admin-dashboard",
  totalRevenue: "admin-total-revenue",
  totalEscrow: "admin-total-escrow",
  totalContracts: "admin-total-contracts",
  contractsTable: "admin-contracts-table",
  releaseBtn: "admin-release-btn",
  refundBtn: "admin-refund-btn",
  chart: "admin-revenue-chart",
  funnelPage: "admin-funnel-page",
  funnelPeriod: "admin-funnel-period",
  funnelRole: "admin-funnel-role",
  funnelStagesTable: "admin-funnel-stages-table",
  funnelTopSources: "admin-funnel-top-sources",
  funnelCompareBrand: "admin-funnel-compare-brand",
  funnelCompareCreator: "admin-funnel-compare-creator",
  financePage: "admin-finance-page",
  financePeriod: "admin-finance-period",
  financeKpiGmv: "admin-finance-kpi-gmv",
  financeKpiRevenue: "admin-finance-kpi-revenue",
  financeKpiEscrow: "admin-finance-kpi-escrow",
  financeKpiPaid: "admin-finance-kpi-paid",
  financeKpiRefunds: "admin-finance-kpi-refunds",
  financeAging: "admin-finance-aging",
  financeCashflowChart: "admin-finance-cashflow-chart",
  financeTopBrands: "admin-finance-top-brands",
  financeTopCreators: "admin-finance-top-creators",
  financeByNiche: "admin-finance-by-niche",
  financeExportTransactions: "admin-finance-export-transactions",
  financeExportEscrow: "admin-finance-export-escrow",
  financeExportWithdrawals: "admin-finance-export-withdrawals",
  financeExportByBrand: "admin-finance-export-by-brand",
  financeExportByCreator: "admin-finance-export-by-creator",
  auditPage: "admin-audit-page",
  auditPeriod: "admin-audit-period",
  auditAction: "admin-audit-action",
  auditSeverity: "admin-audit-severity",
  auditSearch: "admin-audit-search",
  auditTable: "admin-audit-table",
  auditExport: "admin-audit-export",
  auditPrev: "admin-audit-prev",
  auditNext: "admin-audit-next",
  systemLogsPage: "admin-system-logs-page",
  systemLogsPeriod: "admin-system-logs-period",
  systemLogsLevel: "admin-system-logs-level",
  systemLogsTable: "admin-system-logs-table",
  integrationsPage: "admin-integrations-page",
  integrationsRefresh: "admin-integrations-refresh",
  integrationsEmailsTable: "admin-integrations-emails-table",
  integrationsEmailsFilter: "admin-integrations-emails-filter",
};

export const NAV = {
  logo: "nav-logo",
  brandHome: "nav-brand-home",
  brandDiscover: "nav-brand-discover",
  brandCampaigns: "nav-brand-campaigns",
  brandContracts: "nav-brand-contracts",
  creatorHome: "nav-creator-home",
  creatorProfile: "nav-creator-profile",
  creatorContracts: "nav-creator-contracts",
  adminHome: "nav-admin-home",
};
